module.exports = __webpack_public_path__ + "media/images/common/google-calendar-2c1290be3e4bd1a39483199042dae6e3.svg";